import React, { useState, useEffect } from "react";
import styles from "./styles.module.css";
import { Link, useLocation } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PermContactCalendarOutlinedIcon from "@mui/icons-material/PermContactCalendarOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Menubar = () => {
  const Navigate = useNavigate();
  const [activeButton, setActiveButton] = useState("dashboard");
  const location = useLocation();

  useEffect(() => {
    // Update activeButton state based on current pathname
    if (location.pathname === "/dashboard") {
      setActiveButton("dashboard");
    } else if (location.pathname === "/dashboardContactForm" || location.pathname === '/contactDetails/:id') {
      setActiveButton("contact");
    }
  }, [location.pathname]);

  const handleLogout = () => {
    toast.success("You have successfully logout");
    
    // Clear localStorage on logout button click
    localStorage.clear();
    setTimeout(() => {
      Navigate("/");
    }, 2000);
  };

  return (
    <div className={styles.menubar}>
      <div>
        <ToastContainer />
        <Link to="/dashboardjobApplications">
          <div
            className={`${styles.firstMenu} ${
              activeButton === "dashboard" && styles.active
            }`}
          >
            <HomeOutlinedIcon className={styles.firstMenuIcon} />
            <span>Dashboard</span>
          </div>
        </Link>
        <Link to="/dashboardContactForm">
          <div
            className={`${styles.firstMenu} ${
              activeButton === "contact" && styles.active
            }`}
          >
            <PermContactCalendarOutlinedIcon className={styles.firstMenuIcon} />
            <span>Contact us</span>
          </div>
        </Link>
      </div>
      <div>
        <Link to="/dashboardSetting">
          <div
            className={`${styles.firstMenu} ${
              activeButton === "setting" && styles.active
            }`}
          >
            <SettingsOutlinedIcon className={styles.firstMenuIcon} />
            <span>Setting</span>
          </div>
        </Link>
        
          <div
            className={`${styles.firstMenu} ${styles.active}`}
            onClick={handleLogout}
          >
            <LogoutOutlinedIcon className={styles.firstMenuIcon} />
            <span>Logout</span>
          </div>
        
      </div>
    </div>
  );
};

export default Menubar;
